import { QueryDtoOf } from '@40seas/entities/common';
import { Shipping } from './shipping.entity';

export class QueryShippingDto extends QueryDtoOf(Shipping) {}
